// import React, { useEffect, useState } from 'react';
// import {
//   Box, Button, TextField, Typography, ToggleButton, ToggleButtonGroup,
//   Paper, Table, TableBody, TableCell, TableRow, MenuItem, Select
// } from '@mui/material';

// const expectedSchema = {
//   host: 'string',
//   port: 'number',
//   n_logs: 'number',
//   root_ca: 'string',
//   tel_period: 'number',
//   always_on_inet: 'boolean',
// };

// const labelMap = {
//   host: 'Host',
//   port: 'Port',
//   n_logs: 'Number of Logs',
//   root_ca: 'Root CA (Upload .crt/.pem)',
//   tel_period: 'Telemetry Period',
//   always_on_inet: 'Always On Internet',
// };

// function UpdateConfigPage() {
//   const [configs, setConfigs] = useState([]);
//   const [selectedId, setSelectedId] = useState('');
//   const [configData, setConfigData] = useState(null);
//   const [jsonError, setJsonError] = useState('');
//   const [serverResponse, setServerResponse] = useState({ message: '', error: '' });

//   useEffect(() => {
//     fetch('http://localhost:5000/api/config-names')
//       .then(res => res.json())
//       .then(setConfigs)
//       .catch(() => setJsonError('Failed to fetch configuration list'));
//   }, []);

//   useEffect(() => {
//     if (selectedId) {
//       fetch(`http://localhost:5000/api/config/${selectedId}`)
//         .then(res => res.json())
//         .then(data => {
//           setConfigData(data.config);
//           setJsonError('');
//           setServerResponse({ message: '', error: '' });
//         })
//         .catch(() => setJsonError('Failed to fetch config data'));
//     } else {
//       setConfigData(null);
//       setServerResponse({ message: '', error: '' });
//     }
//   }, [selectedId]);

//   const handleFieldChange = (key, type, value) => {
//     const updatedValue = type === 'number' ? Number(value) : value;
//     setConfigData(prev => ({ ...prev, [key]: updatedValue }));
//   };

//   const handleBooleanChange = (key, value) => {
//     setConfigData(prev => ({ ...prev, [key]: value === 'true' }));
//   };

//   const validateSchema = (data) => {
//     return (
//       typeof data === 'object' &&
//       data !== null &&
//       Object.entries(expectedSchema).every(([key, type]) => {
//         if (!(key in data)) return false;
//         return typeof data[key] === type;
//       })
//     );
//   };

//   const handleSave = () => {
//     setServerResponse({ message: '', error: '' });

//     if (!validateSchema(configData)) {
//       setServerResponse({ message: '', error: 'Invalid configuration schema' });
//       return;
//     }

//     fetch('http://localhost:5000/api/update-config', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: selectedId,
//         name: configs.find(c => c.id === Number(selectedId))?.name,
//         config: configData
//       })
//     })
//       .then(async (res) => {
//         if (!res.ok) {
//           const errData = await res.json();
//           throw new Error(errData.error || 'Failed to update configuration');
//         }
//         const data = await res.json();
//         setServerResponse({ message: data.message || 'Configuration updated successfully!', error: '' });
//       })
//       .catch((err) => {
//         setServerResponse({ message: '', error: err.message || 'Failed to update configuration' });
//       });
//   };

//   return (
//     <Box sx={{ maxWidth: 700, margin: 'auto', mt: 4, p: 3 }}>
//       <Typography variant="h5" gutterBottom>Update Configuration</Typography>

//       <Select
//         fullWidth
//         value={selectedId}
//         onChange={(e) => setSelectedId(e.target.value)}
//         displayEmpty
//         sx={{ mb: 3 }}
//       >
//         <MenuItem value="" disabled>Select Config</MenuItem>
//         {configs.map(cfg => (
//           <MenuItem key={cfg.id} value={cfg.id}>
//             {cfg.name}
//           </MenuItem>
//         ))}
//       </Select>

//       {jsonError && (
//         <Typography color="error" sx={{ mb: 2 }}>
//           {jsonError}
//         </Typography>
//       )}

//       {configData && (
//         <Paper variant="outlined" sx={{ p: 2 }}>
//           <Table>
//             <TableBody>
//               {Object.entries(expectedSchema).map(([key, type]) => (
//                 <TableRow key={key}>
//                   <TableCell>
//                     <Typography>{labelMap[key] || key}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     {type === 'boolean' ? (
//                       <ToggleButtonGroup
//                         value={configData[key] ? 'true' : 'false'}
//                         exclusive
//                         onChange={(e, val) => val !== null && handleBooleanChange(key, val)}
//                         size="small"
//                       >
//                         <ToggleButton value="true">True</ToggleButton>
//                         <ToggleButton value="false">False</ToggleButton>
//                       </ToggleButtonGroup>
//                     ) : key === 'root_ca' ? (
//                       <>
//                         <TextField
//                           multiline
//                           rows={3}
//                           fullWidth
//                           value={configData[key]}
//                           onChange={(e) => handleFieldChange(key, 'string', e.target.value)}
//                           sx={{ mb: 1 }}
//                         />
//                         <Button
//                           variant="outlined"
//                           component="label"
//                           size="small"
//                         >
//                           Upload Root CA (.crt/.pem/.txt)
//                           <input
//                             type="file"
//                             hidden
//                             accept=".txt,.pem,.crt"
//                             onChange={(e) => {
//                               const file = e.target.files?.[0];
//                               if (file) {
//                                 const reader = new FileReader();
//                                 reader.onload = () => {
//                                   const content = reader.result;
//                                   if (typeof content === 'string') {
//                                     handleFieldChange(key, 'string', content);
//                                   }
//                                 };
//                                 reader.readAsText(file);
//                               }
//                             }}
//                           />
//                         </Button>
//                       </>
//                     ) : (
//                       <TextField
//                         type={type === 'number' ? 'number' : 'text'}
//                         fullWidth
//                         value={configData[key]}
//                         onChange={(e) => handleFieldChange(key, type, e.target.value)}
//                       />
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>

//           <Button
//             variant="contained"
//             color="primary"
//             sx={{ mt: 2 }}
//             onClick={handleSave}
//           >
//             Save Changes
//           </Button>

//           {serverResponse.error ? (
//             <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//               {serverResponse.error}
//             </Typography>
//           ) : (
//             serverResponse.message && (
//               <Typography color="success.main" sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}>
//                 {serverResponse.message}
//               </Typography>
//             )
//           )}
//         </Paper>
//       )}
//     </Box>
//   );
// }

// export default UpdateConfigPage;
import React, { useEffect, useState } from 'react';
import axios from './AxiosInstance';
import {
  Box, Button, TextField, Typography, ToggleButton, ToggleButtonGroup,
  Paper, Table, TableBody, TableCell, TableRow, MenuItem, Select
} from '@mui/material';

const expectedSchema = {
  host: 'string',
  port: 'number',
  n_logs: 'number',
  root_ca: 'string',
  tel_period: 'number',
  always_on_inet: 'boolean',
};

const labelMap = {
  host: 'Host',
  port: 'Port',
  n_logs: 'Number of Logs',
  root_ca: 'Root CA (Upload .crt/.pem)',
  tel_period: 'Telemetry Period',
  always_on_inet: 'Always On Internet',
};

function UpdateConfigPage() {
  const [configs, setConfigs] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [configData, setConfigData] = useState(null);
  const [jsonError, setJsonError] = useState('');
  const [serverResponse, setServerResponse] = useState({ message: '', error: '' });

  useEffect(() => {
    axios
      .get('/api/config-names')
      .then((res) => setConfigs(res.data))
      .catch(() => setJsonError('Failed to fetch configuration list'));
  }, []);

  useEffect(() => {
    if (selectedId) {
      axios
        .get(`/api/config/${selectedId}`)
        .then((res) => {
          setConfigData(res.data.config);
          setJsonError('');
          setServerResponse({ message: '', error: '' });
        })
        .catch(() => setJsonError('Failed to fetch config data'));
    } else {
      setConfigData(null);
      setServerResponse({ message: '', error: '' });
    }
  }, [selectedId]);

  const handleFieldChange = (key, type, value) => {
    const updatedValue = type === 'number' ? Number(value) : value;
    setConfigData(prev => ({ ...prev, [key]: updatedValue }));
  };

  const handleBooleanChange = (key, value) => {
    setConfigData(prev => ({ ...prev, [key]: value === 'true' }));
  };

  const validateSchema = (data) => {
    return (
      typeof data === 'object' &&
      data !== null &&
      Object.entries(expectedSchema).every(([key, type]) => {
        if (!(key in data)) return false;
        return typeof data[key] === type;
      })
    );
  };

  const handleSave = () => {
    setServerResponse({ message: '', error: '' });

    if (!validateSchema(configData)) {
      setServerResponse({ message: '', error: 'Invalid configuration schema' });
      return;
    }

    const selectedConfig = configs.find(c => c.id === Number(selectedId));
    axios
      .post('/api/update-config', {
        id: selectedId,
        name: selectedConfig?.name,
        config: configData,
      })
      .then((res) => {
        setServerResponse({
          message: res.data.message || 'Configuration updated successfully!',
          error: '',
        });
      })
      .catch((err) => {
        const errorMsg = err.response?.data?.error || err.message || 'Failed to update configuration';
        setServerResponse({ message: '', error: errorMsg });
      });
  };

  return (
    <Box sx={{ maxWidth: 700, margin: 'auto', mt: 4, p: 3 }}>
      <Typography variant="h5" gutterBottom>Update Configuration</Typography>

      <Select
        fullWidth
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value)}
        displayEmpty
        sx={{ mb: 3 }}
      >
        <MenuItem value="" disabled>Select Config</MenuItem>
        {configs.map(cfg => (
          <MenuItem key={cfg.id} value={cfg.id}>
            {cfg.name}
          </MenuItem>
        ))}
      </Select>

      {jsonError && (
        <Typography color="error" sx={{ mb: 2 }}>
          {jsonError}
        </Typography>
      )}

      {configData && (
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Table>
            <TableBody>
              {Object.entries(expectedSchema).map(([key, type]) => (
                <TableRow key={key}>
                  <TableCell>
                    <Typography>{labelMap[key] || key}</Typography>
                  </TableCell>
                  <TableCell>
                    {type === 'boolean' ? (
                      <ToggleButtonGroup
                        value={configData[key] ? 'true' : 'false'}
                        exclusive
                        onChange={(e, val) => val !== null && handleBooleanChange(key, val)}
                        size="small"
                      >
                        <ToggleButton value="true">True</ToggleButton>
                        <ToggleButton value="false">False</ToggleButton>
                      </ToggleButtonGroup>
                    ) : key === 'root_ca' ? (
                      <>
                        <TextField
                          multiline
                          rows={3}
                          fullWidth
                          value={configData[key]}
                          onChange={(e) => handleFieldChange(key, 'string', e.target.value)}
                          sx={{ mb: 1 }}
                        />
                        <Button
                          variant="outlined"
                          component="label"
                          size="small"
                        >
                          Upload Root CA (.crt/.pem/.txt)
                          <input
                            type="file"
                            hidden
                            accept=".txt,.pem,.crt"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                  const content = reader.result;
                                  if (typeof content === 'string') {
                                    handleFieldChange(key, 'string', content);
                                  }
                                };
                                reader.readAsText(file);
                              }
                            }}
                          />
                        </Button>
                      </>
                    ) : (
                      <TextField
                        type={type === 'number' ? 'number' : 'text'}
                        fullWidth
                        value={configData[key]}
                        onChange={(e) => handleFieldChange(key, type, e.target.value)}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleSave}
          >
            Save Changes
          </Button>

          {serverResponse.error ? (
            <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
              {serverResponse.error}
            </Typography>
          ) : (
            serverResponse.message && (
              <Typography color="success.main" sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}>
                {serverResponse.message}
              </Typography>
            )
          )}
        </Paper>
      )}
    </Box>
  );
}

export default UpdateConfigPage;
